export const socialSecurityNumberTools = {
    getAdjustedSsn: ssn => {
        if(ssn === null) {
            return '';
        }
        const ssnToString = String(ssn);
        if(typeof ssn === 'number' && ssnToString.length === 9) {
            return `${ssnToString.slice(0, 3)}-${ssnToString.slice(3, 5)}-${ssnToString.slice(5)}`;
        } else {
            return ssn;
        }

    },

    getOnFocus: ssn => {
        if(ssn === null || ssn === '') {
            return '';
        } else {
            const ssnToString = String(ssn);
            return `${ssnToString.slice(0, 3)}-${ssnToString.slice(3, 5)}-${ssnToString.slice(5)}`;
        }
    },

    formatSSN: ssn => {
        if (!ssn) {
            return '';
        } else {
            const ssnRegex = /^\d{3}-\d{2}-\d{4}$/;
            const maskedRegex = /^\*{3}-\*{2}-\d{4}$/;

            if (ssnRegex.test(ssn) || maskedRegex.test(ssn)) {
                return ssn; // already formatted correctly
            }

            // Keep only digits and asterisks
            const cleaned = ssn.replace(/[^0-9*]/g, '');
            if (cleaned.length !== 9) return ssn; // not enough characters to format

            return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
        }
    },

    cleanedUpSsn: ssn => typeof ssn === 'string' &&
        ssn.split('').filter(ch => ch.match(/^[0-9]*$/)).join(''),

    maskSsn: (ssn, shouldReturnNull = undefined) => {
        if(ssn === null) {
            return shouldReturnNull ? null : '';
        }
        const ssnToString = String(ssn);
        if(ssnToString.length === 9) {
            return `***-**-${ssnToString.slice(5)}`;
        } else {
            return ssn;
        }
    },

    maskSsnLastFour: (ssnLastFour) => {
        if (!ssnLastFour) return '-';
        return `***-**-${ssnLastFour}`;
    },

    autoFillSsn: (ssn, previousSSNValue) => {
        let result;
        switch(true) {
            case ssn.length < previousSSNValue.length:
                switch (ssn.length) {
                    case 0:
                        result = ''; break;
                    case 4:
                        result = ssn.slice(0, ssn.length - 1); break;
                    case 7:
                        result = ssn.slice(0, ssn.length - 1); break;
                    default:
                        result = ssn;
                } break;
            case ssn.length > previousSSNValue.length:
                switch (ssn.length) {
                    case 4:
                        result = `${ssn.slice(0, 3)}-${ssn.slice(-1)}`; break;
                    case 7:
                        result = `${ssn.slice(0, 3)}-${ssn.slice(4, 6)}-${ssn.slice(-1)}`; break;
                    default:
                        result = ssn;
                } break;
            default:
                result = ssn; break;
        }
        return result;
    }
};